"use client";
import { useState } from "react";
import ErrorComponent from "@/components/empty/ErrorComponent";
import { Card, CardHeader } from "@/components/headToHead/Card";
import Table from "@/components/headToHead/Table";
import {
  ToggleButton,
  ToggleSwitch,
} from "@/components/headToHead/ToggleSwitch";
import LoadingBackdrop from "@/components/loadingBackdrop/LoadingBackdrop";
import useGetHeadToHeadTeamStats from "@/utils/hooks/useGetHeadToHeadTeamStats";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import useTable, { TeamTab } from "./useTable";
import styles from "./GameLog.module.scss";

const ContentContainer = ({ tab }: { tab: TeamTab }) => {
  const { gameId } = useHeadToHeadContext();
  const { data, isLoading, isError } = useGetHeadToHeadTeamStats(gameId);
  const { columns, tableData } = useTable(data);
  const selectedTableData =
    tab === TeamTab.Home ? tableData[TeamTab.Home] : tableData[TeamTab.Away];

  if (isError && !data) {
    return <ErrorComponent />;
  } else if (isLoading && !data) {
    return <LoadingBackdrop loading={isLoading} />;
  }
  return <Table data={selectedTableData} columns={columns} />;
};

const GameLog = () => {
  const { awayTeam, homeTeam } = useHeadToHeadContext();
  const awayTeamShortName = awayTeam?.shortName ?? "";
  const homeTeamShortName = homeTeam?.shortName ?? "";
  const [tab, setTab] = useState(TeamTab.Home);

  return (
    <Card>
      <CardHeader
        title="Game Log"
        action={
          <ToggleSwitch>
            <ToggleButton
              label={homeTeamShortName}
              isActive={tab === TeamTab.Home}
              onClick={() => setTab(TeamTab.Home)}
            />
            <ToggleButton
              label={awayTeamShortName}
              isActive={tab === TeamTab.Away}
              onClick={() => setTab(TeamTab.Away)}
            />
          </ToggleSwitch>
        }
      />
      <div className={styles.content}>
        <ContentContainer tab={tab} />
      </div>
    </Card>
  );
};

export default GameLog;
